import React, { useEffect, useState } from "react";
import { Modal, Spin, Button, Popover} from "antd";
import { useDispatch } from "react-redux";
import { setReputation, setNewReputation } from "../../slices/riskSlice";

const TableCellReputationNew = ({item, addNew}) => {

    const dispatch = useDispatch();
    const [reputation2, setStateReputation2] = useState("");
    const [checkedItem, setCheckedItem] = useState(null);
    const [checkedIdreputation, setCheckedIdreputation] = useState("");

	const [addReputation2, setAddReputation2] = useState(false);
    const [reputation, setStateReputation] = useState([]);
    const [reputationArray, setStateReputationArray] = useState([]);
    
    const [reputationArrayUl, setStateReputationArrayUl] = useState([]);

    return (
        <>
            {reputationArray.map((element, index) => 
                <>
                    {element
                        &&
                        <div className={`hovers ${index}`}>
                            <ul style={{padding: '0', margin: '0'}}>
                                {
                                    // console.log(reputationArrayUl)
                                    reputationArrayUl.map((item, indx) =>
                                        (indx == index) && item.map((i, ind) =>
                                        i &&
                                        <li class="autofilss">
                                            <input type="text" className="autofilssInput" onChange={(e) => dispatch(setNewReputation([index.toString(), ind, e.target.value ]))}></input>
                                        </li>
                                    ))
                                }
                                <div className="autofilss">
                                    <button onClick={(e) => {e.preventDefault(); setStateReputationArrayUl(reputationArrayUl.map((item, ind) => (ind == index) ? item = [...item, true] : item));}}>+ Add</button>
                                </div>  
                            </ul>
                        </div>   
                    }    
                </>
            )}
            <div className="autofilss">
                <button onClick={(e) => {e.preventDefault(); setStateReputationArray([...reputationArray, true]); setStateReputationArrayUl([...reputationArrayUl, [true]])}}>+ Add</button>
            </div>  
        </>
    )
};

export default TableCellReputationNew;